import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "../context/AuthContext";
import ScreenLoader from "src/components/UtilityComponents/loaders/screenLoader/ScreenLoader";

const ProtectedRoute = ({ children }) => {
  const { clearAll, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <ScreenLoader />;
  }

  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");
  if (!isAuthenticated || !accessToken || !refreshToken) {
    clearAll();
    return (
      <Navigate
        to={`/login?redirect-url=${encodeURIComponent(location.pathname)}`}
      />
    );
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
